import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import * as types from '../constants/actionTypes';
import { withRouter } from 'react-router';

class LogoutPage extends Component {

  componentDidMount() {
    if(this.props.pageState.auth != null){
      this.props.dispatch({
        type: types.LOGOUT__REQUESTED
      });
    }
  }

  render() {
    return (<span>Logged out</span>);
  }
}

LogoutPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  pageState: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired
};

function mapStateToProps(state) {

  return {
    pageState: state
  };
}

export default connect(mapStateToProps)(withRouter(LogoutPage));




/** WEBPACK FOOTER **
 ** ./src/containers/LogoutPage.js
 **/